import type { Position } from '../../../shared/types';

export function distanceBetweenPoints(a: Position, b: Position) {
	return Math.sqrt((b.latitude - a.latitude) ** 2 + (b.longitude - a.longitude) ** 2);
}
